import { useRouter } from 'next/router'
import Cookies from 'js-cookie'

import { ROUTE_ADMIN_HOME, ROUTES_CLIENT, TOKEN_ADMIN, TOKEN_CLIENT } from '@/utils/constants'
import useUserStore, { useModalLoadingStore } from '@/utils/store/store'
import type { User } from '@/components/common/Providers/GraphqlProvider/generated'
import { Cookie } from '@next/font/google'

export const getTokenFromCookies = (path?: string) => {
  // Si no se proporciona path, intentamos obtener la ruta actual del navegador
  const currentPath = path || (typeof window !== 'undefined' ? window.location.pathname : '')

  if (currentPath.startsWith('/admin')) {
    return Cookies.get(TOKEN_ADMIN) || Cookies.get('token')
  }
  return Cookies.get('token') || Cookies.get(TOKEN_ADMIN)
}

export const useLoginConfirm = () => {
  const { save } = useUserStore()
  const { showLoading } = useModalLoadingStore()
  const { push, replace, query, asPath } = useRouter()

  const saveToken = (remember: boolean, token: string) => {
    const expires = remember ? { expires: 365, path: '/' } : {}
    Cookies.set(TOKEN_ADMIN, token, { ...expires, sameSite: 'Lax' })
  }

  const logInConfirm = async (remember: boolean, token: string, user: User) => {
    // const expires = remember ? { expires: 365, path: '/' } : { path: '/' }

    saveToken(remember, token)
    const dependencyIdFromCookie = Cookies.get('dependencyId')

    save({ user: user, token: token })
    if (query.p && dependencyIdFromCookie && token) {
      location.replace(query.p as string)
    } else {
      replace(ROUTE_ADMIN_HOME)
    }
    showLoading(false)
  }

  const logInConfirmClient = async (
    remember: boolean,
    token: string,
    user: User,
    hasRedirect = true
  ) => {
    const expires = remember && { expires: 365, path: '/' }
    Cookies.set(TOKEN_CLIENT, token, { ...expires })
    save({ user: user, token: token })
    if (hasRedirect) {
      if (query.redirect) {
        location.replace(query.redirect as string)
        return
      }
      replace(ROUTES_CLIENT.DASHBOARD)
    }
  }

  return { logInConfirm, logInConfirmClient, saveToken }
}
